import React from "react"
import ReactDOM from "react-dom"
import Header from "./header-component"
import NoticeBanner from "./notice-banner"

export default class HeaderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.loginState = (elem.dataset.loginState && JSON.parse(elem.dataset.loginState)) || {}
    self.searchConfig = (elem.dataset.inputSearch && JSON.parse(elem.dataset.inputSearch)) || {}
    self.languages = (elem.dataset.languages && JSON.parse(elem.dataset.languages)) || {}
    self.init()
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)

    const currentUniverse = self.modelJson?.universes.filter((u) => u && u.currentUniverse)[0]

    ReactDOM.render(
      <header>
        <Header
          key={"site-header"}
          accessibilityHeaderItems={currentUniverse?.accessibilityHeaderItems || self.modelJson.accessibilityHeaderItems}
          onlyTopLevel={self.modelJson.disableMegaMenu}
          headerLinks={currentUniverse?.headerLinks || self.modelJson.headerLinks}
          logo={self.modelJson.logo}
          logoOverride={self.modelJson.logoOverride}
          logoLink={self.modelJson.logoLink}
          searchResultsPageLink={self.modelJson.searchResultsPageLink}
          shopLogo={currentUniverse?.shopLogo || self.modelJson.shopLogo}
          shopLogoLink={currentUniverse?.shopLogoLink || self.modelJson.shopLogoLink}
          shopLogoLinkTarget={currentUniverse?.shopLogoLinkTarget || self.modelJson.shopLogoLinkTarget}
          universes={self.modelJson.universes}
          universeSelection={self.modelJson?.universes || undefined}
          universesSelectText={self.modelJson.universesSelectText || "CPH Websites"}
          openBurgerMenuAriaLabel={self.modelJson.openBurgerMenuAriaLabel}
          closeBurgerMenuAriaLabel={self.modelJson.closeBurgerMenuAriaLabel}
          menuToggleLabel={self.modelJson.menuToggleLabel}
          langChoiceAriaLabel={self.modelJson.langChoiceAriaLabel}
          searchButtonAriaLabel={self.modelJson.searchButtonAriaLabel}
          searchClearInputButtonAriaLabel={self.modelJson.searchClearInputButtonAriaLabel}
          taxFreeAriaLabel={self.modelJson.taxFreeAriaLabel}
          sectionNotAvailableText={self.modelJson.sectionNotAvailableText}
          pageNotAvailableText={self.modelJson.pageNotAvailableText}
          languages={self.languages}
          locale={self.locale}
          loginState={self.loginState}
          searchConfig={self.searchConfig}
          showLogin={currentUniverse?.showLogin || self.modelJson.showLogin}
        />
        <NoticeBanner noticeBannerText={self.modelJson.noticeBannerText} languageNotAvailable={self.modelJson.languageNotAvailable} />
      </header>,
      self.elem,
    )
  }
}
